import React, { useRef } from "react";
import { useState } from "react";
import {
    Avatar,
    Button,
    CloseIcon,
    Dialog,
    EditIcon,
    Flex,
    Text,
} from "@fluentui/react-northstar";
import styled from "styled-components/macro";
import { Link, useNavigate, useParams } from "react-router-dom";
import CardUser from "./CardUser";
import { CustomBadge } from "../../../../../components/Badge";
import {
    PeopleTeam16Filled,
    BuildingBank16Filled,
} from "@fluentui/react-icons";
import BadgeIcon from "../../BadgeIcon";
import Supervise from "../../Dialogs/Supervise";
import { ROUTES } from "../../../../../constants/routes";
import { ROLES_CODE, roles_access } from "../../../../../constants/roles";
import DialogUpdateManagerContent from "../../Dialogs/DialogUpdateManagerContent";
import DialogUpdateRhContent from "../../Dialogs/DialogUpdateRhContent";
import DialogUpdateSupervisorManager from "../../Dialogs/DialogUpdateSupervisorManager";
import DialogUpdateManager from "../../Dialogs/DialogUpdateManagerContent/DialogUpdateManager";
import DialogUpdateHr from "../../Dialogs/DialogUpdateHr";
import DialogUpdateAgencyDepartment from "../../Dialogs/DialogUpdateAgencyDepartmentContent/DialogUpdateAgencyDepartment";
import { DEVICE } from "../../../../../constants/responsive";
import {
    _api_get_header_informations,
    api_update_new_manager,
    api_update_new_rh,
} from "../../../api";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useToastGlobal } from "../../../../../stores/useToastGlobal";
import { QUERY_KEY } from "../../../constants";
import DialogUpdateSupervisorHumainRessource from "../../Dialogs/DialogUpdateSupervisorHumainRessource/DialogUpdateSupervisorHumainRessource";

const CardPositionEntreprise = ({
    teamManager,
    teamHr,
    manager,
    rh,
    default_agency_id,
    default_service_id,
    agency_name,
    department_name,
    isEmployeeManager,
    isEmployeeHR,
}) => {
    const toast = useToastGlobal();
    const navigate = useNavigate();
    const clientQuery = useQueryClient();
    // * STATES
    // * STATES
    // * STATES
    const [newManager, setNewManager] = useState(null);
    const [newRh, setNewRH] = useState(null);

    const [openDialogModifyManager, setOpenDialogModifymanager] =
        useState(false);

    const [openDialogModifyHR, setOpenDialogModifyHR] = useState(false);
    const [
        openDialogModifySupervisorManager,
        setOpenDialogModifySupervisorManager,
    ] = useState(false);
    const [
        openDialogModifySupervisorHumainRessource,
        setOpenDialogModifySupervisorHumainRessource,
    ] = useState(false);

    const [
        openDialogModifyAgencyDepartment,
        setOpenDialogModifyAgencyDepartment,
    ] = useState(false);
    //* QUERY
    //* QUERY

    const { id_employee } = useParams();

    const { data: header_data, isLoading: header_loading } = useQuery(
        [QUERY_KEY + "::header", id_employee],
        () => _api_get_header_informations(id_employee),
        {
            refetchOnWindowFocus: false,
            onSuccess: (header_data) => {
                if (header_data) {
                    document.title = ` Dossier de  ${header_data?.display_name}`;
                }
            },
        }
    );

    //* QUERY
    //* QUERY

    //* MUTATION
    //* MUTATION
    //* MUTATION

    const {
        mutate: mutateUpdateManager,
        isLoading: isLoadingMutateUpdateManager,
    } = useMutation((data) => {
        return api_update_new_manager({
            user_ids: data.user_ids,
            manager_id: data.manager_id,
        });
    });

    const { mutate: mutateUpdateRh, isLoading: isLoadingMutateUpdateRh } =
        useMutation((data) => {
            return api_update_new_rh({
                user_ids: data.user_ids,
                hr_id: data.hr_id,
            });
        });

    const len_team_manager = teamManager?.length;
    const len_team_hr = teamHr?.length;

    // * check if the user is HR

    const isHR = roles_access({
        usersPrivileges: [ROLES_CODE.hr],
    });
    // * check if the user is HR

    // * open or close dialogs functions
    const _openOrCloseDialogModifyManager = (bool) => {
        return setOpenDialogModifymanager(bool);
    };

    const _openOrCloseDialogModifyHR = (bool) => {
        return setOpenDialogModifyHR(bool);
    };

    const _openOrCloseDialogModifyAgencyDepartment = (bool) => {
        return setOpenDialogModifyAgencyDepartment(bool);
    };
    const _openOrCloseDialogModifySupervisorHumainRessource = (bool) => {
        return setOpenDialogModifySupervisorHumainRessource(bool);
    };

    const _openOrCloseDialogModifySupervisorManager = (bool) => {
        return setOpenDialogModifySupervisorManager(bool);
    };

    // * navigate to any employee
    const _navigateToEmployee = (id) => {
        if (isNaN(id)) {
            return console.log("is not a valid ID employee");
        }

        return navigate(ROUTES.employee_folder.custom_route(id));
    };

    const selectedUsersRef = useRef([]);

    const handleSelectionChange = (selectedUsers) => {
        selectedUsersRef.current = selectedUsers;
    };

    //* SEND DATA VIA MUTATE
    //* SEND DATA VIA MUTATE
    //* SEND DATA VIA MUTATE
    const changeEmployeeManager = () => {
        // console.log("Utilisateurs sélectionnés :", selectedUsersRef.current);
        // console.log("Nouveau manager sélectionné :", newManager?.id);
        return mutateUpdateManager(
            {
                user_ids: selectedUsersRef.current,
                manager_id: newManager?.id,
            },
            {
                onSuccess: (response) => {
                    // console.log({ response });
                    if (response?.success) {
                        toast.setShow({
                            content: "Manager Modifié",
                            level: "success",
                            visible: true,
                            dismissible: true,
                        });
                        clientQuery.refetchQueries([QUERY_KEY + "::about"]);
                        setOpenDialogModifySupervisorManager(false);
                    } else {
                        toast.setShow({
                            content: "Erreur lors de modification du manager",
                            level: "danger",
                            visible: true,
                            dismissible: true,
                        });
                    }
                },
            }
        );
    };
    const changeEmployeeRH = () => {
        return mutateUpdateRh(
            {
                user_ids: selectedUsersRef.current,
                hr_id: newRh?.id,
            },
            {
                onSuccess: (response) => {
                    // console.log({ response });
                    if (response?.success) {
                        toast.setShow({
                            content: "RH Modifié ",
                            level: "success",
                            visible: true,
                            dismissible: true,
                        });
                        clientQuery.refetchQueries([QUERY_KEY + "::about"]);
                        setOpenDialogModifySupervisorHumainRessource(false);
                    } else {
                        toast.setShow({
                            content: "Erreur lors de modification du RH",
                            level: "danger",
                            visible: true,
                            dismissible: true,
                        });
                    }
                },
            }
        );
        // Exemple : envoyer à une API
        // axios.post('/api/send', selectedUsersRef.current)
    };

    return (
        <WrapperPositionSociety>
            {/* dialogs */}
            <DialogUpdateManager
                open_default={openDialogModifyManager}
                onClose={() => _openOrCloseDialogModifyManager(false)}
                default_manager={manager}
            />
            <DialogUpdateHr
                default_hr={rh}
                open_default={openDialogModifyHR}
                onClose={() => _openOrCloseDialogModifyHR(false)}
            />

            <DialogUpdateAgencyDepartment
                open_default={openDialogModifyAgencyDepartment}
                default_agency_id={default_agency_id}
                default_service_id={default_service_id}
                onClose={() => _openOrCloseDialogModifyAgencyDepartment(false)}
            />
            {/* dialog for modify Supervisor of manager team */}
            <Dialog
                open={openDialogModifySupervisorManager}
                header="Modifier la supervision Manager"
                content={
                    <DialogUpdateSupervisorManager
                        manager={header_data}
                        teamManager={teamManager}
                        onSelectionChange={handleSelectionChange}
                        setNewManager={setNewManager}
                    />
                }
                onCancel={() =>
                    _openOrCloseDialogModifySupervisorManager(false)
                }
                confirmButton={{
                    loading: isLoadingMutateUpdateManager,
                    content: "Confirmer",
                    flat: true,
                    onClick: () => {
                        changeEmployeeManager();
                    },
                }}
                cancelButton={{
                    content: "Annuler",
                    flat: true,
                }}
                styles={{
                    width: "391px",
                }}
            />
            {/* dialog for modify serpervisor humain ressource */}
            <Dialog
                open={openDialogModifySupervisorHumainRessource}
                header="Modifier la supervision RH"
                content={
                    <DialogUpdateSupervisorHumainRessource
                        rh={header_data}
                        teamHr={teamHr}
                        onSelectionChange={handleSelectionChange}
                        setNewRH={setNewRH}
                    />
                }
                onCancel={() =>
                    _openOrCloseDialogModifySupervisorHumainRessource(false)
                }
                confirmButton={{
                    // loading: isLoadingMutateUpdateManager,
                    content: "Confirmer",
                    flat: true,
                    onClick: () => {
                        changeEmployeeRH();
                    },
                }}
                cancelButton={{
                    content: "Annuler",
                    flat: true,
                }}
                styles={{
                    width: "391px",
                }}
            />
            <div>
                <Title content={"Position dans l'entreprise"} />
            </div>
            {/* manager & HR */}
            <Supervisors>
                <CardUser
                    full_name={`${manager?.first_name} ${manager?.last_name}`}
                    job_title={manager?.job_title}
                    title="Manager"
                    avatar={manager?.avatar}
                    canModify={isHR}
                    onClick={() => _navigateToEmployee(manager?.id)}
                    onModify={() => _openOrCloseDialogModifyManager(true)}
                />
                <CardUser
                    full_name={`${rh?.first_name} ${rh?.last_name}`}
                    job_title={rh?.job_title}
                    title="RH"
                    avatar={rh?.avatar}
                    onClick={() => _navigateToEmployee(rh?.id)}
                    canModify={isHR}
                    onModify={() => _openOrCloseDialogModifyHR(true)}
                />
                <Flex
                    column
                    gap="gap.small"
                    hAlign="start"
                    fill
                    styles={{
                        maxWidth: "240px",
                        flexBasis: "240px",
                        flexShrink: 0,
                        maxHeight: "fit-content",
                    }}
                >
                    <Flex space="between" fill vAlign="center">
                        <Title content={"Agence & département"} />
                        {isHR && (
                            <Button
                                primary
                                text
                                iconOnly
                                icon={<EditIcon />}
                                onClick={() =>
                                    _openOrCloseDialogModifyAgencyDepartment(
                                        true
                                    )
                                }
                                flat
                            />
                        )}
                    </Flex>
                    <BadgeIcon
                        icon={<PeopleTeam16Filled color=" #616161" />}
                        content={agency_name}
                    />
                    <BadgeIcon
                        icon={<BuildingBank16Filled color=" #616161" />}
                        content={department_name}
                    />
                </Flex>
            </Supervisors>
            {/* Team Manager */}
            {isEmployeeManager && (
                <Flex column>
                    <Flex column gap="gap.medium">
                        <Flex space="between">
                            <Text
                                content={
                                    <SubTitle>
                                        Supervise en tant que <b>Manager</b>{" "}
                                        <CustomBadge
                                            bg="orange"
                                            color="white"
                                            label={`${len_team_manager}`}
                                            size="smaller"
                                        />
                                    </SubTitle>
                                }
                            />
                            {isHR && len_team_manager > 0 && (
                                <Button
                                    tinted
                                    content="Modifier"
                                    flat
                                    onClick={() =>
                                        _openOrCloseDialogModifySupervisorManager(
                                            true
                                        )
                                    }
                                />
                            )}
                        </Flex>
                        <ManagerSuperviser>
                            {!len_team_manager && (
                                <EmptyEmployees content="Aucune personne trouvée" />
                            )}
                            {teamManager?.slice(0, 6)?.map((employee) => {
                                return (
                                    <CardUser
                                        key={employee?.id}
                                        avatar={employee?.avatar}
                                        full_name={`${employee?.first_name} ${employee?.last_name}`}
                                        job_title={employee?.job_title}
                                        hideTitle={true}
                                        onClick={() =>
                                            _navigateToEmployee(employee?.id)
                                        }
                                    />
                                );
                            })}
                        </ManagerSuperviser>
                    </Flex>
                    {len_team_manager > 6 && (
                        <Supervise
                            header="Supervise en tant que Manager"
                            users={teamManager}
                        />
                    )}
                </Flex>
            )}
            {/* Team HR */}
            {isEmployeeHR && (
                <Flex column>
                    <Flex column gap="gap.medium">
                        <Flex space="between">
                            <Text
                                content={
                                    <SubTitle>
                                        Supervise en tant que <b>RH</b>{" "}
                                        <CustomBadge
                                            bg="orange"
                                            color="white"
                                            label={`${len_team_hr}`}
                                            size="smaller"
                                        />
                                    </SubTitle>
                                }
                            />
                            {isHR && len_team_hr && (
                                <Button
                                    onClick={() =>
                                        _openOrCloseDialogModifySupervisorHumainRessource(
                                            true
                                        )
                                    }
                                    tinted
                                    content="Modifier"
                                    flat
                                />
                            )}
                        </Flex>
                        <HRSuperviser>
                            {!len_team_hr && (
                                <EmptyEmployees content="Aucune personne trouvée" />
                            )}
                            {teamHr?.slice(0, 6)?.map((employee) => {
                                return (
                                    <CardUser
                                        avatar={employee?.avatar}
                                        full_name={`${employee?.first_name} ${employee?.last_name}`}
                                        job_title={employee?.job_title}
                                        hideTitle={true}
                                        onClick={() =>
                                            _navigateToEmployee(employee?.id)
                                        }
                                    />
                                );
                            })}
                        </HRSuperviser>
                    </Flex>
                    {len_team_hr > 6 && (
                        <Supervise
                            header="Supervise en tant que RH"
                            users={teamHr}
                        />
                    )}
                </Flex>
            )}
        </WrapperPositionSociety>
    );
};

export default CardPositionEntreprise;

const ManagerSuperviser = styled(Flex)`
    @media ${DEVICE.mobileS} {
        gap: 32px;
        row-gap: 0px;
        flex-wrap: wrap;
        justify-content: center;
    }
    @media ${DEVICE.mobileM} {
    }
    @media ${DEVICE.mobileL} {
        justify-content: flex-start;
        gap: 8px;
        row-gap: 0px;
    }
    @media ${DEVICE.tablet} {
        gap: 16px;
        row-gap: 0px;
    }
    @media ${DEVICE.laptop} {
        gap: 26px;
        row-gap: 0px;
    }
`;

const HRSuperviser = styled(ManagerSuperviser)``;

const Supervisors = styled(Flex)`
    flex-wrap: wrap;
    @media ${DEVICE.mobileS} {
        gap: 32px;
        flex-direction: column;
        row-gap: 0px;
    }
    @media ${DEVICE.mobileM} {
    }
    @media ${DEVICE.mobileL} {
        flex-direction: row;
        flex-wrap: wrap;
        row-gap: 0px;
        gap: 8px;
    }
    @media ${DEVICE.tablet} {
        flex-wrap: wrap;
        gap: 32px;
        row-gap: 0px;
    }
    @media ${DEVICE.laptop} {
        flex-wrap: wrap;
    }
    @media ${DEVICE.laptopL} {
        justify-content: space-between;
    }
`;

const WrapperPositionSociety = styled(Flex)`
    width: 100%;
    @media ${DEVICE.mobileS} {
        flex-direction: column;
        gap: 32px;
    }
    @media ${DEVICE.mobileM} {
    }
    @media ${DEVICE.mobileL} {
    }
    @media ${DEVICE.tablet} {
    }
    @media ${DEVICE.laptop} {
    }
    @media ${DEVICE.laptopL} {
    }
`;

const EmptyEmployees = styled(Text)`
    font-style: italic;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #616161;
    margin-bottom: 16px;
`;

const SubTitle = styled(Text)`
    color: #242424;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
`;

const Title = styled(Text)`
    color: #242424;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
`;
